import React, { useCallback, useState } from "react";

import { FieldType, FieldTypeExtra } from "components/FieldType";

export const FieldArguments = ({ argument }) => {
  const [showDetails, setShowDetails] = useState(false);
  const handleFieldsExpand = useCallback(
    (e) => {
      e.preventDefault();
      setShowDetails(!showDetails);
    },
    [showDetails, setShowDetails]
  );

  if (!argument.args || argument.args.length < 1) return null;

  return (
    <span>
      <span className="expand-item" onClick={handleFieldsExpand}>
        {showDetails ? "-" : "+"}
      </span>
      {showDetails && (
        <div>
          <div className="expanded-item">
            {argument.args && argument.args.length > 0 && <h3>Arguments</h3>}
            {argument.args &&
              argument.args.map((f) => (
                <div className="object-field-details" key={f.name}>
                  <span className="object-field-details-name">{f.name}</span>
                  {"  "}
                  (<FieldType field={f} />){"  "}
                  <FieldTypeExtra field={f} />
                </div>
              ))}
          </div>
        </div>
      )}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/components/FieldArguments.jsx